import React from 'react';
import AlertRulesPage from './alertRules/AlertRulesPage';

const Alerts = () => <AlertRulesPage />;

export default Alerts;
